import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Button,
  ButtonBase,
  Card,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  Fade,
  Icon,
  IconButton,
  Grid,
  Stack,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ReactPlayer from "react-player";
import { AddCircle, ArrowBackIosNew, Movie, Photo, RemoveCircle, Search } from "@mui/icons-material";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { AppSingleton, data_list } from "../services/user_config";
import { getExercises } from "../services/backend";
import { MediaCard } from "../components/exercise-detail-card-component";

const AdminPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [currentRow, setCurrentRow] = useState(null);
  // const [imageSrc, setImageSrc] = useState(null);
  // const [videoSrc, setVideoSrc] = useState(null);

  const columns = [
    {
      field: "title",
      headerName: "Title",
      minWidth: 192,
      align: "left",
      isHide: false,
      renderCell: (params) => (
        <Tooltip
          title={
            <div style={{ whiteSpace: "pre-line" }}>{`Title: ${params?.row?.title}\nSubTitle: ${params?.row?.subtitle}`}</div>
            // <Box>
            //   <Typography>{`Title: ${params?.row?.title}`}</Typography>
            //   <Typography>{`SubTitle: ${params?.row?.subtitle}`}</Typography>
            //   {/* <div style={{ whiteSpace: "pre-line" }}>{`Title: ${params?.row?.title}\nSubTitle: ${params?.row?.subtitle}`}</div> */}
            // </Box>
          }
        >
          {params?.row?.title}
        </Tooltip>
      ),
    },
    { field: "status", headerName: "Status", isHide: false },
    { field: "duration", headerName: "Duration", isHide: false },
    { field: "calories", headerName: "Calories", align: "center", isHide: false },
    {
      field: "difficulty",
      headerName: "Difficulty",
      isHide: false,
      renderCell: (params) => (
        <Tooltip
          title={
            <Box>
              {params?.row?.tags.map((tag, i) => (
                <Chip key={`Tooptip-tags-${i}`} label={`${tag}`} />
              ))}
            </Box>
          }
        >
          {params?.row?.difficulty}
        </Tooltip>
      ),
    },
    { field: "trainer", headerName: "Trainer", minWidth: 192, isHide: false },
    {
      field: "imageUrl",
      headerName: "imageUrl",
      isHide: false,
      renderCell: (params) => (
        <Tooltip title={<img src={`/img/${params?.row?.imageUrl}`} width={256} height={256} />}>
          <Photo />
        </Tooltip>
      ),
    },
    {
      field: "videoUrl",
      headerName: "videoUrl",
      isHide: false,
      renderCell: (params) => (
        <Tooltip
          title={
            <Box>
              <ReactPlayer
                sx={{ width: 256, height: 256 }}
                url={`/video/${params?.row?.videoUrl}`}
                playing
                muted
                loop
                playsinline
                width="100%"
                height="100%"
              />
            </Box>
          }
        >
          <Movie />
        </Tooltip>
      ),
    },
    {
      field: "explore",
      headerName: "Explore",
      isHide: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => {
            console.log("row");
            console.log({ ...params?.row });
            setCurrentRow({ ...params?.row });
          }}
        >
          <Search />
        </IconButton>
      ),
    },
  ].map((c) => ({ ...c, headerAlign: c.headerAlign ? c.headerAlign : "center", align: c.align ? c.align : "center" }));

  const _getExercises = async () => {
    setIsLoading(true);
    const { data } = await getExercises();
    const exercises = data?.exercises.map((el) => ({ ...el, id: el.exercise_id }));
    setRows(exercises);
    setIsLoading(false);
  };

  useEffect(() => {
    _getExercises();
  }, []);

  return (
    <Box sx={{ ml: "2%", mr: "2%" }}>
      <Box sx={{ m: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Card sx={{ paddingTop: "50%", backgroundColor: "grey" }}>
              <Box> 1111111111111</Box>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{ paddingTop: "50%", backgroundColor: "grey" }}>
              <Box> 22222222222</Box>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{ paddingTop: "50%", backgroundColor: "grey" }}>
              <Box> 3333333333</Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ height: 400, width: "100%" }}>
        <Typography
          color="primary"
          sx={{
            fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(18) : getAdaptivFontSize(24)),
          }}
        >
          Exercise List
        </Typography>
        <DataGrid
          loading={isLoading}
          rows={rows}
          // columns={columns.map((c) => ({ ...c, renderCell: c.renderCell ? c.renderCell : "a" }))}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          // checkboxSelection
          disableRowSelectionOnClick
          // tooltipProps={{
          //   getContent: (params) => {
          //     return `Custom Text: ${params.row.title}`;
          //   },
          // }}
        />
      </Box>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={currentRow !== null}
        onClose={() => {
          setCurrentRow(null);
        }}
      >
        <MediaCard
          currentRow={currentRow}
          onClose={() => setCurrentRow(null)}
          onUpdate={(d) => {
            setCurrentRow(null);
            setTimeout(() => {
              _getExercises();
            }, 500);
          }}
        />
      </Dialog>
    </Box>
  );
};

const f = () => {};

export { AdminPage, f };
